import React from 'react';
import {moveSourcesFile, moveSourcesFolder} from './sourcesApi';

const normalizeFolderId = (folderId) => folderId ?? null;

const useSourcesMoveEntry = ({userId}) => {
    return React.useCallback((entry, targetFolderId) => {
        if (!userId) {
            return Promise.reject(new Error('An authenticated user is required to move files and folders.'));
        }

        const parentFolderId = normalizeFolderId(targetFolderId);

        if (entry.itemType === 'folder') {
            if (parentFolderId && String(parentFolderId) === String(entry.id)) {
                return Promise.resolve();
            }

            return moveSourcesFolder({
                folderId: entry.id,
                userId,
                parentFolderId,
            });
        }

        return moveSourcesFile({
            fileId: entry.id,
            userId,
            parentFolderId,
        });
    }, [userId]);
};

export default useSourcesMoveEntry;
